export const COMPANY_BENEFITS = "COMPANY"
export const EXTERNAL = "EXTERNAL"
